<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 22V26C8 26.5523 8.44772 27 9 27H13" stroke="var(--icon-color)" stroke-width="2" stroke-linecap="round" />
    <path
        d="M19 26.5L19 28C19 28.5523 19.4477 29 20 29L28 29C28.5523 29 29 28.5523 29 28L29 17C29 16.4477 28.5523 16 28 16L20 16C19.4477 16 19 16.4477 19 17L19 19"
        stroke="var(--icon-color)" stroke-width="2" />
    <path d="M16 23L25 23" stroke="var(--icon-color)" stroke-width="2" />
    <path d="M22 20L25 23.0169L22.0337 26" stroke="var(--icon-color)" stroke-width="2" />
    <path d="M1 12L15 12" stroke="var(--icon-color)" stroke-width="2" />
    <path d="M2 12V2H9M9 2L14 7M9 2V7H14M14 7V12" stroke="var(--icon-color)" stroke-width="2" />
    <path d="M5 12V16" stroke="var(--icon-color)" stroke-width="2" stroke-linecap="round" />
    <path d="M2 12V16" stroke="var(--icon-color)" stroke-width="2" stroke-linecap="round" />
    <path d="M14 12V16" stroke="var(--icon-color)" stroke-width="2" stroke-linecap="round" />
    <path d="M5 19V20" stroke="var(--icon-color)" stroke-width="2" stroke-linecap="round" />
    <path d="M8 17L8 18" stroke="var(--icon-color)" stroke-width="2" stroke-linecap="round" />
    <path d="M11 12L11 19" stroke="var(--icon-color)" stroke-width="2" stroke-linecap="round" />
    <path d="M8 12V14" stroke="var(--icon-color)" stroke-width="2" stroke-linecap="round" />
</svg>
